import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { messageTaskComponent } from './messageTask.component';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { RadioButtonModule } from 'primeng-lts/radiobutton';

@NgModule({
  declarations: [messageTaskComponent],
  imports: [TranslateModule, CommonModule, CheckboxModule, FormsModule, RouterModule, RadioButtonModule]
})
export class MessageTaskModule { }
